import { ScrollView, StyleSheet, Text, View, Image, FlatList } from 'react-native'
import React, { useMemo, useState } from 'react'
import { ThemedText, ThemedView } from '@app/theme'
import { ThemedTouchableOpacity } from '@app/theme/Components'
import { trackEvent } from '@app/utils'





const BankLogo = ({ code }: { code: string }) => {

  const [logo, setLogo] = useState<string>(`https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${code}.png`)

  return (
    <Image onError={() => {
      setLogo(`https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/default.png`)
    }} source={{ uri: logo }} style={{ width: 36, height: 36 }} />
  )
}

// onBankSelect: (bankCode: string, bankName: string) => void



const AllBanks = React.memo(({ banks, onBankSelect, showTitle = true }: { banks: Record<string, string>, onBankSelect: (bankCode: string, bankName: string) => void, showTitle?: boolean }) => {



  const handleBankPress = (bankId: string) => {
    trackEvent('BANK_SELECT_ALL_BANKS_SELECTED', { bankId })
    onBankSelect(bankId, banks[bankId])
  }

  const sortedBanks = useMemo(() => {
    return Object.entries(banks).sort((a, b) => a[1].localeCompare(b[1]))
  }, [banks])

  return (
    <ThemedView flex={1}>
      {showTitle && <ThemedText mb='lg' variant='b3s' color='text-primary'>All other banks</ThemedText>}
      <FlatList
        data={sortedBanks}
        keyExtractor={(item) => item[0]}
        renderItem={({ item }) => (
          <ThemedTouchableOpacity onPress={() => handleBankPress(item[0])} flexDirection='row' alignItems='center' mb='2xl' key={item[0]}>
            <BankLogo code={item[0]} />
            <ThemedText ml='md' variant='b3r'>{item[1]}</ThemedText>
          </ThemedTouchableOpacity>
        )}
        initialNumToRender={15}
        maxToRenderPerBatch={15}
        windowSize={5}
        showsVerticalScrollIndicator={false}
        keyboardShouldPersistTaps="handled"
      />
    </ThemedView>
  )
})

export default AllBanks

const styles = StyleSheet.create({})